import { WozCaseComplaintQuestionEntity } from './woz-case-complaint-question.entity';
import { WozCaseComplaintReferenceEntity } from './woz-case-complaint-reference.entity';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type WozCaseComplaintEntityInput = Omit<Partial<WozCaseComplaintEntity>, 'questions' | 'references'> & { questions?: any[]; references?: any[] };

/**
 * Entity mirroring `case_complaints` table.
 */
export class WozCaseComplaintEntity {
  id: string | null;
  sequence: number;
  categoryCode: string | null;
  correctedText: string | null;
  formattedText: string | null;
  hash: string;
  text: string;
  questions: WozCaseComplaintQuestionEntity[];
  references: WozCaseComplaintReferenceEntity[];
  classificationRationale: string | null;
  detectedReferences: string[];

  constructor(data: WozCaseComplaintEntityInput = {}) {
    this.id = data.id ?? null;
    this.sequence = data.sequence ?? 0;
    this.categoryCode = data.categoryCode ?? null;
    this.correctedText = data.correctedText ?? null;
    this.formattedText = data.formattedText ?? null;
    this.hash = data.hash ?? '';
    this.text = data.text ?? '';
    this.questions = (data.questions ?? []).map((q) =>
      q instanceof WozCaseComplaintQuestionEntity ? q : new WozCaseComplaintQuestionEntity(q)
    );
    this.references = (data.references ?? []).map((r) =>
      r instanceof WozCaseComplaintReferenceEntity ? r : new WozCaseComplaintReferenceEntity(r)
    );
    this.classificationRationale = data.classificationRationale ?? null;
    this.detectedReferences = data.detectedReferences ?? [];
  }

  toJSON() {
    return {
      id: this.id,
      sequence: this.sequence,
      categoryCode: this.categoryCode,
      correctedText: this.correctedText,
      formattedText: this.formattedText,
      hash: this.hash,
      text: this.text,
      questions: this.questions.map((q) => q.toJSON()),
      references: this.references.map((r) => r.toJSON()),
      classificationRationale: this.classificationRationale,
      detectedReferences: this.detectedReferences,
    };
  }
}
